import React from "react";
import { Button } from "antd";
import axios from "axios";
import "antd/dist/antd.css";

export const DeleteVersion = ({ version_id, token, onUpdate, isDeleted }) => {
  const handleDelete = () => {
    axios
      .post(
        process.env.REACT_APP_API + "/api/mobile_app/delete",
        { version_id },
        {
          headers: {
            Authorization: token
          }
        }
      )
      .then(response => {
        console.log(response);
        onUpdate();
      })
      .catch(error => console.error(error));
  };

  const handleReactivate = () => {
    axios
      .post(
        process.env.REACT_APP_API + "/api/mobile_app/reactivate",
        { version_id },
        {
          headers: {
            Authorization: token
          }
        }
      )
      .then(response => {
        console.log(response);
        onUpdate();
      })
      .catch(error => console.error(error));
  };

  return (
    <div>
      {isDeleted ? (
        <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={handleReactivate}>
          Réactiver la version
        </Button>
      ) : (
        <Button className="bg-red-500 text-white px-4 py-2 rounded" onClick={handleDelete}>
          Supprimer la version
        </Button>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/DeleteVersion.js